// removed by extract-text-webpack-plugin
module.exports = {"base":"Levels_base--2A6Lg","item":"Levels_item--1iyBC","item__active":"Levels_item__active--eIqfr","itemActive":"Levels_item__active--eIqfr","title":"Levels_title--3kY51","description":"Levels_description--2uLxL"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/Filters/components/Levels/Levels.scss
// module id = 2281
// module chunks = 11